import Link from 'next/link';

import { Typography } from '../../components/typography/typography-component';

export default function ReleaseLogFooter() {
  return (
    <div className="w-full bg-[#064649] px-4 py-12">
      <div className="mx-auto px-2 md:container sm:w-full md:px-0">
        <div className="flex flex-col justify-between gap-y-8 md:flex-row">
          <div className="flex flex-col gap-4 text-white">
            <Link href="/" aria-label="Home">
              <Typography variant="h4" className="font-GTWalsheimPro">
                Releaselog.io
              </Typography>
            </Link>
            <Typography variant="paragraph" className="font-avenir text-white">
              We are part of the{'  '}
              <a
                href="https://earlynode.com"
                target="_blank"
                className="underline"
                rel="noreferrer"
              >
                EarlyNode
              </a>{' '}
              family.
              <br />
              {new Date().getFullYear()} Relelaselog. All rights reserved.
            </Typography>
          </div>

          <div className="flex min-w-[150px] flex-col gap-4 text-white">
            <Typography variant="h5" className="font-GTWalsheimPro">
              About
            </Typography>
            <Link href="/imprint">
              <Typography
                variant="paragraph"
                className="font-avenir opacity-80"
              >
                Imprint
              </Typography>
            </Link>
            <Link href="/privacy">
              <Typography
                variant="paragraph"
                className="font-avenir opacity-80"
              >
                Privacy
              </Typography>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
